/* Homepage hero overlay — 1:1 clone of leaveslighting.com hero copy + layout.
   Injected into each PageFly SlideshowSlide (leaves-74fc). */
(function () {
  if (!document.documentElement || document.documentElement.dataset.leavesVuoriHero === '1') return;
  document.documentElement.dataset.leavesVuoriHero = '1';

  var SELECTOR = '#leaves-home [data-section-id="leaves-74fc"]';
  var AUTOPLAY_MS = 5500;
  var ICON_PAUSE =
    '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
    '<rect x="2" y="1.5" width="2.75" height="9" rx="0.5"></rect>' +
    '<rect x="7.25" y="1.5" width="2.75" height="9" rx="0.5"></rect>' +
    '</svg>';
  var ICON_PLAY =
    '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
    '<path d="M3.2 1.4v9.2L10.4 6z"></path>' +
    '</svg>';

  /* Match official homepage slide order (same 4 scene images). */
  var SLIDES = [
    {
      title: 'Designed for the spaces you live in after dark.',
      body: 'Two simple parts. Endless ways to shape your outdoor lighting design.',
      cta: 'Shop Now',
      href: '/pages/configure-v2',
    },
    {
      title: 'Bend it by hand.',
      body: 'The Color Bridge wire shapes around corners, trees, pergolas and more — no electrician needed.',
      cta: 'See how it works',
      href: '/pages/how-it-works',
    },
    {
      title: 'Clip the lights wherever you want.',
      body: 'Every fixture clips directly to the wire. Move them in seconds.',
      cta: 'Works',
      href: '/pages/how-it-works',
    },
    {
      title: 'Start with a kit. Make it yours.',
      body: 'Four starter kits. Endless possibilities. Our kits cover most spaces and can be customized to create the perfect lighting solution for your space.',
      cta: 'Start Building',
      href: '/pages/configure-v2',
    },
  ];

  function build(section) {
    if (section.querySelector('.leaves-vuori-hero')) return true;
    var slides = section.querySelectorAll('[data-leaves-type="SlideshowSlide"]');
    if (!slides.length) return false;

    Array.prototype.forEach.call(slides, function (slide, index) {
      var data = SLIDES[index] || SLIDES[0];

      var shade = document.createElement('div');
      shade.className = 'leaves-vuori-hero__shade';
      shade.setAttribute('aria-hidden', 'true');
      slide.appendChild(shade);

      var card = document.createElement('div');
      card.className = 'leaves-vuori-hero';

      /* Official layout: stage → centered 80rem shell → 40rem copy block */
      var shell = document.createElement('div');
      shell.className = 'leaves-vuori-hero__shell';

      var inner = document.createElement('div');
      inner.className = 'leaves-vuori-hero__inner';

      var heading = document.createElement('h2');
      heading.className = 'leaves-vuori-hero__title';
      heading.textContent = data.title;
      inner.appendChild(heading);

      var copy = document.createElement('p');
      copy.className = 'leaves-vuori-hero__body';
      copy.textContent = data.body;
      inner.appendChild(copy);

      var actions = document.createElement('div');
      actions.className = 'leaves-vuori-hero__actions';

      var cta = document.createElement('a');
      cta.className = 'leaves-vuori-hero__cta';
      cta.href = data.href;
      cta.textContent = data.cta;
      actions.appendChild(cta);

      inner.appendChild(actions);
      shell.appendChild(inner);
      card.appendChild(shell);
      slide.appendChild(card);
    });

    section.setAttribute('data-hero-built', '1');
    wireSliders(section);
    return true;
  }

  function wireSliders(root) {
    var sliders = (root || document).querySelectorAll('.leaves-slider');
    Array.prototype.forEach.call(sliders, wireSlider);
  }

  function wireSlider(slider) {
    if (!slider || slider.getAttribute('data-leaves-slider') === '1') return;
    var slides = [];
    Array.prototype.forEach.call(slider.children, function (child) {
      if (child.classList && child.classList.contains('leaves-slide')) slides.push(child);
    });
    if (!slides.length) return;
    slider.setAttribute('data-leaves-slider', '1');
    var nav = null;
    var prev = null;
    var next = null;
    Array.prototype.forEach.call(slider.children, function (child) {
      if (!child.classList) return;
      if (child.classList.contains('leaves-slider-nav')) nav = child;
      if (child.classList.contains('leaves-slider-prev')) prev = child;
      if (child.classList.contains('leaves-slider-next')) next = child;
    });

    var isHero = !!(slider.closest && slider.closest('[data-section-id="leaves-74fc"]'));

    function current() {
      var width = slider.clientWidth || 1;
      return Math.round(slider.scrollLeft / width);
    }

    var autoplayTimer = null;

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isHero || !controls || controls.classList.contains('is-paused')) return;
      autoplayTimer = window.setTimeout(function () {
        go(current() + 1);
      }, AUTOPLAY_MS);
    }

    function go(index) {
      var count = slides.length;
      var nextIndex = ((index % count) + count) % count;
      var slide = slides[nextIndex];
      if (slide) slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      startAutoplay();
    }

    var lastMarked = -1;

    function navButtons() {
      if (!nav) return [];
      var list = [];
      Array.prototype.forEach.call(nav.children, function (child) {
        if (child.tagName === 'BUTTON') list.push(child);
      });
      return list;
    }

    function restartFill(btn) {
      if (!btn || (controls && controls.classList.contains('is-paused'))) {
        if (btn) btn.classList.remove('is-filling');
        return;
      }
      btn.classList.remove('is-filling');
      void btn.offsetWidth;
      btn.classList.add('is-filling');
    }

    function mark(forceRestart) {
      if (!nav) return;
      var active = current();
      var buttons = navButtons();
      Array.prototype.forEach.call(buttons, function (btn, index) {
        var on = index === active;
        btn.classList.toggle('active', on);
        if (!on) btn.classList.remove('is-filling');
      });
      if (isHero && (forceRestart || active !== lastMarked)) {
        lastMarked = active;
        restartFill(buttons[active]);
      }
    }

    if (nav && !navButtons().length) {
      slides.forEach(function (slide, index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Slide ' + (index + 1));
        if (index === 0) btn.className = 'active';
        btn.addEventListener('click', function () {
          go(index);
        });
        nav.appendChild(btn);
      });
    }

    var controls = null;
    var playBtn = null;

    if (isHero && nav) {
      controls = slider.querySelector('.leaves-hero-controls');
      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'leaves-hero-controls';
        playBtn = document.createElement('button');
        playBtn.type = 'button';
        playBtn.className = 'leaves-hero-play';
        playBtn.setAttribute('aria-label', 'Pause slideshow');
        playBtn.innerHTML = ICON_PAUSE;
        nav.parentNode.insertBefore(controls, nav);
        controls.appendChild(playBtn);
        controls.appendChild(nav);
      } else {
        playBtn = controls.querySelector('.leaves-hero-play');
      }

      controls.style.setProperty('--leaves-hero-ms', AUTOPLAY_MS + 'ms');

      function setPaused(paused) {
        controls.classList.toggle('is-paused', paused);
        if (!playBtn) return;
        playBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        playBtn.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
        var active = nav.querySelector('button.active');
        if (paused) {
          stopAutoplay();
          if (active) active.classList.remove('is-filling');
        } else if (active) {
          restartFill(active);
          startAutoplay();
        }
      }

      if (playBtn && playBtn.getAttribute('data-wired') !== '1') {
        playBtn.setAttribute('data-wired', '1');
        playBtn.addEventListener('click', function () {
          setPaused(!controls.classList.contains('is-paused'));
        });
      }

      var first = nav.querySelector('button.active') || nav.querySelector('button');
      if (first) restartFill(first);
      startAutoplay();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(current() - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        go(current() + 1);
      });
    }
    slider.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(function () {
          mark(false);
        });
      },
      { passive: true }
    );
  }

  function showNav(section) {
    var controls = section.querySelector('.leaves-hero-controls');
    if (controls) controls.classList.add('is-in');
    var nav = section.querySelector('.leaves-slider-nav.pagination-style-3');
    if (nav) nav.classList.add('is-in');
  }

  function clearBar(section) {
    var bar = section.querySelector('.leaves-hero-bar');
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
  }

  function replayNav(section) {
    var controls = section.querySelector('.leaves-hero-controls');
    var target = controls || section.querySelector('.leaves-slider-nav.pagination-style-3');
    if (!target) return;
    if (!target.getAttribute('data-seen')) {
      target.setAttribute('data-seen', '1');
      target.classList.add('is-in');
      return;
    }
    target.classList.remove('is-in');
    void target.offsetWidth;
    target.classList.add('is-in');
  }

  function watch(section) {
    var slides = section.querySelectorAll('.leaves-slide');
    if (!window.IntersectionObserver) {
      Array.prototype.forEach.call(section.querySelectorAll('.leaves-vuori-hero'), function (card) {
        card.classList.add('is-in');
      });
      replayNav(section);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target.querySelector('.leaves-vuori-hero');
          if (!card) return;
          if (entry.intersectionRatio >= 0.72) {
            card.classList.add('is-in');
            replayNav(section);
          } else if (!entry.isIntersecting) {
            card.classList.remove('is-in');
          }
        });
      },
      { threshold: [0, 0.72] }
    );
    Array.prototype.forEach.call(slides, function (slide) {
      io.observe(slide);
    });
  }

  function run() {
    var section = document.querySelector(SELECTOR);
    if (!section) return false;
    if (build(section)) {
      clearBar(section);
      showNav(section);
      watch(section);
      wireSliders(document.getElementById('leaves-home') || document);
      return true;
    }
    return false;
  }

  var _observer = null;

  function boot() {
    if (run()) return;
    _observer = new MutationObserver(function () {
      if (run()) {
        _observer.disconnect();
        _observer = null;
      }
    });
    _observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      if (_observer) {
        _observer.disconnect();
        _observer = null;
      }
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
